import React from "react";
import { ProtectedRoute, ProtectedRouteProps } from "./ProtectedRoute";

export function lazyProtected(
  importFn: () => Promise<any>,
  { niveauRattachements = [], perimetres = [], redirectTo = "/" }: ProtectedRouteProps
) {
  return async () => {
    const module = await importFn();
    return {
      ...module,
      Component: () => (
        <ProtectedRoute
          niveauRattachements={niveauRattachements}
          perimetres={perimetres}
          redirectTo={redirectTo}
        >
          <module.Component />
        </ProtectedRoute>
      ),
    };
  };
}
